module.exports = __webpack_public_path__ + "static/media/flag-spain.04cba928.svg";